import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Comma = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.91 11.91c0 14.713-9.408 27.323-22.419 32.027-.5.2-1.1-.1-1.3-.6-.201-.5.1-1.201.6-1.301 9.808-3.503 17.414-11.81 20.017-22.019-2.202 2.402-5.305 3.903-8.808 3.903a11.875 11.875 0 0 1-11.91-11.91C10.09 5.305 15.395 0 22 0c6.606 0 11.91 5.304 11.91 11.91Z"
  }));
});
Comma.displayName = 'Comma';
Comma.defaultProps = {
  'aria-label': 'Comma'
};
export default Comma;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Editor/Comma.js
// module id = 3537
// module chunks = 11